/**
 * Copyright (c) Granthika Co., All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 */

type ErrorObjectType = { ok: boolean, error: string, errorType? : string, cause?: Error}
export class GranthikaError extends Error {

  // Error type constants
  public static FAILED_REQUEST = 'failedRequest' // means the HTTP request did not succeed, either 400+ or 500+ error

  nextAction: string = ''
  dismissLabel: string = 'Ok'
  additionalInfo: string = ''
  
  constructor(readonly errorObject: ErrorObjectType)  {
    super(errorObject.error || errorObject.errorType || 'unknown error')
  }

  get ok() {
    return this.errorObject.ok
  }

  get fatal() {
    return this.errorObject.errorType != "accountDeleted"
  }

  get message() {
    return this.errorObject.error
  }

  get type() {
    return this.errorObject.errorType
  }

  get cause() {
    return this.errorObject.cause || null
  }

  static make(error: any): GranthikaError {
    if (error instanceof GranthikaError)
      return error as GranthikaError
    else if (typeof error === 'string' || error instanceof String) {
      try {
        let parsedError = JSON.parse(error as string) 
        if (typeof parsedError == "object" && (parsedError as object).hasOwnProperty('ok')) {
          return new GranthikaError(parsedError as ErrorObjectType)
        }
      }
      catch (e) {
      }
      return new GranthikaError({ok:false, error: error as string, errorType: 'unknown'})
    }
    else if (error instanceof Error)
      return new GranthikaError({ok:false, error: String(error), errorType: "Error", cause: error})
    else if (error instanceof Object && error['error'])
      return new GranthikaError({ok:false, error: String(error['error']), errorType: error['errorType'] || 'unknown'})
    else
      return new GranthikaError({ok:false, error: String(error), errorType: 'unknown'})
  }

  static none = new GranthikaError({ok:true, error:''})
}